import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle'
import '@fortawesome/fontawesome-free/css/all.min.css'
import Menu from './components/modules/Menu';
import { BrowserRouter, Route,Routes } from 'react-router-dom';
import Home from './components/pages/Home';
import Nosotros from './components/pages/Nosotros';
import Contactenos from './components/pages/Contactenos';
import Vlog from './components/modules/Vlog';
import { useEffect } from 'react';
import Footer from './components/modules/Footer';
import FormHeader from './components/modules/FormHeader';
import Servicios from './components/pages/Servicios';
import MarcoNormativo from './components/modules/MarcoNormativo';
import Galerias from './components/pages/Galerias';
import Convenios from './components/pages/Convenios';
import PoliticaTratamientoDatos from './components/pages/PoliticaTratamientoDatos';
import GaleriaComunicados from './components/modules/Comunicados/GaleriaComunicados';

///APOYO EMPRESARIAL
import ApoyoEmpresarial from './components/modules/Galerias/apoyo_empresarial/index';
import Taganga202505 from './components/modules/Galerias/apoyo_empresarial/202505_taganga/index';

///BIENESTAR SOCIAL
import BienestarSocial from './components/modules/Galerias/bienestar_social/index';
import Anchetas2023 from './components/modules/Galerias/bienestar_social/202312_anchetas/index';
import Anchetas2024 from './components/modules/Galerias/bienestar_social/202412_anchetas/index';
import Anchetas2025 from './components/modules/Galerias/bienestar_social/202512_anchetas/index';
import Deporte2024 from './components/modules/Galerias/bienestar_social/20240526_uniformes/index';
import Cultura2024 from './components/modules/Galerias/bienestar_social/202407_cultura/index';
import Vivienda202604 from './components/modules/Galerias/bienestar_social/202604_vivienda/index';

///CAPACITACIONES
import Capacitaciones from './components/modules/Galerias/capacitaciones/index';
import Economia2023 from './components/modules/Galerias/capacitaciones/2023_economia/index';
import Salud2024 from './components/modules/Galerias/capacitaciones/2024_salud/index';


///FORTALECIMIENTO ECONOMICO
import Economico from './components/modules/Galerias/fortalecimiento_economico/index';



///GESTION FINANCIERA
import Financiera from './components/modules/Galerias/gestion_financiera/index';
import Pesem2025 from './components/modules/Galerias/gestion_financiera/2025_Pesem/index';


///COMUNICADOS
import ListaAsociadosInhabiles from './components/modules/Institucional/202511-asociados-inhabiles';

function App() {

  
  useEffect(()=>{
    
    document.title = "Coopmulmag";
    //document.body.style.backgroundImage=Fondo;
    });


  return (
    <div className="container bg-light"  >
      
      <BrowserRouter>      
      <Menu></Menu>
      
      <div className='border-top border-3'></div>
      <Routes>
        <Route  path="/institucional/nosotros" element={<Nosotros/>} ></Route>
        <Route  path="/institucional/ejes-estrategicos" element={<Servicios/>} ></Route>
        <Route  path="/institucional/marco-normativo" element={<MarcoNormativo/>} ></Route>
        <Route  path="/institucional/tratamiento-datos" element={<PoliticaTratamientoDatos/>} ></Route>
        <Route  path="/institucional/asociados-inhabiles" element={<ListaAsociadosInhabiles/>} ></Route>
        <Route  path="/institucional/comunicados" element={<GaleriaComunicados/>} ></Route>
        <Route  path="/contactenos" element={<Contactenos/>} ></Route>
        <Route  path="/vlog" element={<Vlog/>} ></Route>
        <Route  path="/galeria" element={<Galerias/>} ></Route>

        <Route  path="/galeria/apoyo-empresarial" element={<ApoyoEmpresarial/>} ></Route>
        <Route  path="/galeria/apoyo-empresarial/taganga-202505" element={<Taganga202505/>} ></Route>

        <Route  path="/galeria/bienestar-social" element={<BienestarSocial/>} ></Route>
        <Route  path="/galeria/bienestar-social/anchetas-2023" element={<Anchetas2023/>} ></Route>
        <Route  path="/galeria/bienestar-social/anchetas-2024" element={<Anchetas2024/>} ></Route>
        <Route  path="/galeria/bienestar-social/anchetas-2025" element={<Anchetas2025/>} ></Route>
        <Route  path="/galeria/bienestar-social/deporte-2024" element={<Deporte2024/>} ></Route>
        <Route  path="/galeria/bienestar-social/cultura-2024" element={<Cultura2024/>} ></Route>
        <Route  path="/galeria/bienestar-social/vivienda-202604" element={<Vivienda202604/>} ></Route>

        
        <Route  path="/galeria/capacitaciones" element={<Capacitaciones/>} ></Route>
        <Route  path="/galeria/capacitaciones/economia-2023" element={<Economia2023/>} ></Route>
        <Route  path="/galeria/capacitaciones/salud-2024" element={<Salud2024/>} ></Route>

        
        <Route  path="/galeria/fortalecimiento-economico" element={<Economico/>} ></Route>
        <Route  path="/galeria/fortalecimiento-economico/economia-2023" element={<Economia2023/>} ></Route>

        
        <Route  path="/galeria/gestion-financiera" element={<Financiera/>} ></Route>
        <Route  path="/galeria/gestion-financiera/pesem-2025" element={<Pesem2025/>} ></Route>


        <Route  path="/convenios" element={<Convenios/>} ></Route>
        <Route  path="/" element={<Home/>}></Route>
        <Route  path="*" element={<Home/>}></Route>


      </Routes>      
      </BrowserRouter>    
      <hr></hr>  
      <Footer></Footer>
    </div>
  );
}

export default App;
